module.exports = __webpack_public_path__ + "static/media/pngaaa.com-560798.60ff96d5.png";